import React, { Suspense, lazy, createElement } from 'react';
import ErrorBoundary from './components/ErrorBoundary';

function App({ module }) {
  const moduleName = module.charAt(0).toUpperCase() + module.slice(1);
  if (moduleName === '' || moduleName === 'None') {
    return null
  }
  const LazyComponent = lazy(() => import('./components/' + moduleName));
  return (
    <div className="app">
      <ErrorBoundary>
        <Suspense fallback={<div>{Drupal.t('Loading...')}</div>}>
          {LazyComponent && createElement(LazyComponent)}
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}

export default App;
